module.exports = __webpack_public_path__ + "img/welcome.6299356a.svg";